<!DOCTYPE html>
<template>
<div id="app">

  <Header :user="user" />
  <b-container>
    <router-view class="main"
                 :user="user"></router-view>
  </b-container>
  <Footer :user="user" />

</div>
</template>

<script>
const firebase = require( '@/firebaseConfig.js' )
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },
  metaInfo() {
    return {
      meta: [
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }

  },
  created() {
    firebase.firebase.auth().onAuthStateChanged( this.toggleUserStatus )
  },
  computed: {
    user() {
      return this.$root.user
    },
  },
  methods: {
    toggleUserStatus( user ) {
      if ( user ) {
        this.$root.user = user
      } else {
        this.$root.user = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";

#app {
    font-family: 'fa-brands';
    font-family: 'Futura-X';
}
</style>
